export function getManifestFitKey({ uploadData, sessionId, activeView }) {
  return `${uploadData?.session_id ?? sessionId ?? 'none'}-${activeView}`
}
